export default __webpack_public_path__ + "static/media/Promotion-of-Access-to-Information.f3880ce6.pdf";